import uuidV4 from 'lib/string/uuidV4Utils'
import { FetchReviewsOkResponse } from 'api/review'

export function userReviewsMap(response: FetchReviewsOkResponse): App.ReviewsFetch {
  const { result, total } = response

  // We need to ensure all reviews have an ID for use on the CP as unique key
  return {
    total,
    reviews: result.map(review => ({
      id: review.id || uuidV4(),
      ...review,
    })),
  }
}
